module.exports = __webpack_public_path__ + "img/weizhi.a02cfb45.png";